<template>
  <!-- name: '其他页面容器' -->
  <div class="otherWrap">
    <AboutUS v-if="$route.query.title === '关于我们'" />
    <Notice v-if="$route.query.title === '捐赠/申领须知'" />
    <SupportUs v-if="$route.query.title === '支持我们'" />
    <Carbon v-if="$route.query.title === '减碳值'" />
    <Volunteer v-if="$route.query.title === '志愿者服务记录'" />
    <Cert v-if="$route.query.title === '捐衣海报'" />
    <Backlinks v-else :title="$route.query.title" :link="$route.query.link" />
  </div>
</template>

<script>
import AboutUS from "./components/aboutUs.vue";
import Notice from "./components/notice.vue";
import SupportUs from "./components/supportUs.vue";
import Carbon from "./components/carbon.vue";
import Volunteer from "./components/volunteer.vue";
import Cert from "./components/cert.vue";
import Backlinks from "./components/backlinks.vue";


export default {
  components: { AboutUS, Notice, SupportUs, Carbon, Volunteer, Cert, Backlinks },
  data() {
    return {};
  },
  created() { },
  methods: {},
};
</script>

<style lang="scss" scoped>
.otherWrap {
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding-bottom: 37px;
}
</style>
